import { PaywallDisplay, setDisplayState } from 'redux/slices/paywall'
import React, { useCallback } from 'react'

import { Divider } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { useDispatch } from 'react-redux'
import { useStyles } from './styles'

interface GoBackPaywallButtonProps {
    step: PaywallDisplay
    onGoBack?: Function
}

export const GoBackPaywallButton: React.FC<GoBackPaywallButtonProps> = ({ step, onGoBack }) => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const goBack = useCallback(() => {
        dispatch(setDisplayState(step))
        onGoBack && onGoBack()
    }, [dispatch, step, onGoBack])

    return (
        <div>
            <button className={classes.button} onClick={goBack} id="paywall-back-btn">
                <FontAwesomeIcon className={classes.icon} icon={faChevronLeft} />
                <span className={classes.buttonText}>Back</span>
            </button>
            <Divider className={classes.divider} />
        </div>
    )
}

export default React.memo(GoBackPaywallButton)
